import { render, staticRenderFns } from "./ReturnOrderFail.vue?vue&type=template&id=32e30a85&scoped=true&"
import script from "./ReturnOrderFail.vue?vue&type=script&lang=js&"
export * from "./ReturnOrderFail.vue?vue&type=script&lang=js&"
import style0 from "./ReturnOrderFail.vue?vue&type=style&index=0&id=32e30a85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e30a85",
  null
  
)

export default component.exports